import { ReactNode, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { Helmet } from 'react-helmet'

import { trackEvent } from '@/utils/analytics'

import { AuthMain } from './components/AuthMain'

interface AuthLayoutProps {
  children: ReactNode
}

const AuthLayout: React.FC<AuthLayoutProps> = ({ children }) => {
  const location = useLocation()

  useEffect(() => {
    trackEvent('AuthLayout', 'PageView', location.pathname)
  }, [location])

  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <AuthMain>{children}</AuthMain>
    </>
  )
}

export default AuthLayout
